export default "__VITE_ASSET__a5e142fc__"